
import { useStore } from "effector-react";
import { useEffect, useState } from "react";
import {  queryDems } from "../../../../pages/demands/logics/demands";
import { $accounts, $selectedAccountId } from "../../../accounts2";
import { $SiteColors } from "../../../config/company-atts";
import { Preloader } from "../../Preloader/preloader";
import { $Notifications, getNotifications, INotification } from "../logics/notificationsLogic";
import { NotificationItem } from "./NotificationItem";


export const Notifications = () => {
  const [openMenu, setOpenMenu] = useState(false)
  const notificationsAnalog = useStore($Notifications)
  const [error, setError] = useState('')
  const [notifications, setNotifications] = useState<INotification[]>([] as INotification[])
  const currentAccount = useStore($selectedAccountId)
  const [loading,setLoading]=useState(false)

  useEffect(() => {
    if (openMenu)
      if ($accounts.getState().accounts.length > 0) {
        setError('')
        setLoading(true)
        getNotifications($selectedAccountId.getState())
      }
      else {
        setError('Уведомлений нет')
      }


  }, [openMenu])
 
  useEffect(() => {
    setLoading(false)
    setNotifications(notificationsAnalog)
  }, [notificationsAnalog])

  useEffect(() => {
    setOpenMenu(false)
    let companyId = $accounts.getState().accounts.find(e=>e.id === currentAccount)?.companyId
    setNotifications([])
    queryDems({accountId: (currentAccount == -1 ? "" : `${currentAccount}`), companyId: `${companyId}`})
  }, [currentAccount])
  return (
    <div className="logo__container">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 22" onClick={() =>{setOpenMenu(!openMenu)}} style={{ cursor: 'pointer' }}>
        <path
          d="M4 8a6 6 0 014.03-5.67 2 2 0 113.95 0A6 6 0 0116 8v6l3 2v1H1v-1l3-2V8zm8 10a2 2 0 11-4 0h4z"
          fill={$SiteColors.getState().headerTextColor}
        />
      </svg>
      {openMenu ?
        <div className="notification_opened" style={error ? { height: "100px" } : {}}>
          <div style={{ display: 'flex', justifyContent: "center", marginBottom: "1rem" }}>
            <div className="logo__container" style={{ position: "absolute", left: "10px", top: "10px" }}>
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 22" onClick={() => setOpenMenu(!openMenu)} style={{ cursor: 'pointer' }}>
                <path
                  d="M4 8a6 6 0 014.03-5.67 2 2 0 113.95 0A6 6 0 0116 8v6l3 2v1H1v-1l3-2V8zm8 10a2 2 0 11-4 0h4z"
                  fill={"#3D4652"}
                />
              </svg>
            </div>
            <span style={{ fontWeight: 700, fontSize: "1.1rem", color: "#3D4652" }}>Уведомления</span>
          </div>

          <div className="notification_array">
            {loading?
            <div style={{display:"flex", width:"100%",height:"90%", justifyContent:"center", alignItems:"center"}}>
            <Preloader small={false} />
            </div>
            :notifications?notifications.length > 0?notifications.map((e, i) => {
              return <NotificationItem key={i} notify={e} setOpenMenu={setOpenMenu}/>
            }):<p style={{ textAlign: "center" }}>Аккаунт не загрузился, попробуйте еще раз</p>:
            <p style={{ textAlign: "center" }}>Аккаунт не загрузился, попробуйте еще раз</p>}
            {error.length>0 ? <p style={{ textAlign: "center" }}>{error}</p> : null}

          </div>

        </div>
        : <></>}
       
    </div>
  );
};
function setUpdFreeDems(arg0: boolean) {
  throw new Error("Function not implemented.");
}

